import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP_URL } from "../siteData";

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_URL}
      className="floating-whatsapp"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with MS Universal Distributors on WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
}
